<template>
  <table
    v-if="materialList.length > 0"
    class="my-3 table-auto"
    aria-label="MaterialList"
  >
    <thead class="uppercase">
      <tr>
        <th>Bezeichnung</th>
        <th>Menge</th>
        <th>Artikelnummer</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(object, index) in materialList" :key="index">
        <td>{{ object.description }}</td>
        <td>{{ object.amount }}</td>
        <td>{{ object.articleReference }}</td>
      </tr>
    </tbody>
  </table>
  <div v-else class="py-4">Artikelliste ist leer</div>
</template>

<script setup lang="ts">
import { OrderArticle } from '@/models/types/Order';

const props = defineProps<{
  materialList: Array<OrderArticle>;
}>();
</script>
